<template lang="pug">
.new-feedback
  shForm(title="Nuevo reporte")
</template>

<script>
import shForm from '@/components/pages/feedback/Form'

export default {
  name: 'NewFeedback',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-feedback
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/feedback/New.vue